import htmlLoggedIn from './logged-in.html'
import htmlLoggedOut from './logged-out.html'
import './styles.css'

import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'
import { fillString } from '@local_modules/generic/string-template.js'

const ELEMENT_NAME = 'header-authenticated'

class HeaderAuthenticated extends HTMLElement {
  static observedAttributes = ['data-loaded']

  // constructor () {
  //   super()
  // }

  attributeChangedCallback (property, oldValue, newValue) {
    if (oldValue === newValue) return
    this[property] = newValue

    this.render()
  }

  connectedCallback () {
    // console.log('connectedCallback', this)
    this.render()
  }

  render () {
    // console.log('render', ELEMENT_NAME, this)
    if (this.getAttribute('data-loaded') === 'false') {
      this.innerHTML = `
      <div class="navbar-item" style="min-width: 200px;">
        <progress class="progress is-small is-info" max="100">Loading</progress>
      </div>
      `
      return
    }

    if (browserAppUser.isLoggedIn()) {
      const menu = fillString(htmlLoggedIn, { username: browserAppUser.data?.appUser?.name })
      this.innerHTML = menu
    } else {
      this.innerHTML = htmlLoggedOut
    }
  }

  set dataLoaded (value) {
    this.setAttribute('data-loaded', value)
  }

  get dataLoaded () {
    return this.getAttribute('data-loaded')
  }
}

customElements.define(ELEMENT_NAME, HeaderAuthenticated)
